import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            服务分类
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            按需选择最适合您的体育服务
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            四大核心服务板块，精准匹配您的运动需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/categories?tab=${category.slug}`}
              className="group flex flex-col md:flex-row bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full md:w-48 h-40 md:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent md:bg-gradient-to-r"></div>
              </div>
              <div className="flex-1 p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className={`${category.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900">{category.name}</h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {category.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {category.features.slice(0, 3).map((feature, idx) => (
                    <span
                      key={idx}
                      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium"
                    >
                      <i className="ri-check-line text-[10px]"></i>
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}